import React from 'react';

const PartnersTab = ({ project }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          Partner Requests & Quotes
        </h3>
        <button className="px-4 py-2 bg-blue-600 dark:bg-blue-700 text-white rounded-md hover:bg-blue-700 dark:hover:bg-blue-800">
          Request New Quote
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {(project.project_partner_requests || []).map((request) => (
          <div
            key={request.id}
            className="bg-white dark:bg-gray-800 p-6 rounded-lg border border-gray-200 dark:border-gray-700"
          >
            <div className="flex justify-between items-start">
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white">
                  {request.partners?.name || 'Partner'}
                </h4>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                  {request.partners?.company}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Specialties: {request.partners?.specialties?.join(', ') || 'N/A'}
                </p>
                {request.quote_amount_aud && (
                  <p className="text-sm font-medium text-green-600 dark:text-green-400 mt-1">
                    Quote: ${request.quote_amount_aud.toLocaleString()}
                  </p>
                )}
              </div>
              <span
                className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                  request.status === 'accepted'
                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                    : request.status === 'submitted'
                    ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
                    : request.status === 'declined'
                    ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                    : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
                }`}
              >
                {request.status.toUpperCase()}
              </span>
            </div>

            {request.status === 'submitted' && (
              <div className="mt-4 flex gap-2">
                <button className="px-3 py-1 bg-green-600 dark:bg-green-700 text-white text-sm rounded hover:bg-green-700 dark:hover:bg-green-800">
                  Accept Quote
                </button>
                <button className="px-3 py-1 bg-red-600 dark:bg-red-700 text-white text-sm rounded hover:bg-red-700 dark:hover:bg-red-800">
                  Decline
                </button>
              </div>
            )}

            {request.quote_url && (
              <div className="mt-2">
                <a
                  href={request.quote_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-sm"
                >
                  View Quote Document →
                </a>
              </div>
            )}
          </div>
        ))}
        {(!project.project_partner_requests || project.project_partner_requests.length === 0) && (
          <div className="text-center py-8 text-gray-500 dark:text-gray-400">
            No partner requests yet. Request quotes from qualified contractors.
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnersTab;


